/**
 * Scroll-spy for long-form detail table of contents (case study + article).
 */
function initDetailToc(listSelector, linkSelector) {
	const toc = document.querySelector(listSelector);
	if (!toc) {
		return;
	}

	const links = [...toc.querySelectorAll(linkSelector)];
	if (!links.length) {
		return;
	}

	const sections = links
		.map((link) => {
			const id = link.dataset.tocTarget;
			return id ? document.getElementById(id) : null;
		})
		.filter(Boolean);

	if (!sections.length) {
		return;
	}

	const setActive = (activeId) => {
		links.forEach((link) => {
			link.classList.toggle('is-active', link.dataset.tocTarget === activeId);
		});
	};

	// Smooth-scroll to the target section, offset for the sticky header.
	links.forEach((link) => {
		link.addEventListener('click', (event) => {
			const target = document.getElementById(link.dataset.tocTarget);
			if (!target) {
				return;
			}
			event.preventDefault();
			const offset = 120;
			const top = target.getBoundingClientRect().top + window.scrollY - offset;
			window.scrollTo({ top, behavior: 'smooth' });
			setActive(link.dataset.tocTarget);
		});
	});

	if (!('IntersectionObserver' in window)) {
		setActive(sections[0].id);
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			const visible = entries
				.filter((entry) => entry.isIntersecting)
				.sort((a, b) => b.intersectionRatio - a.intersectionRatio);

			if (visible.length) {
				setActive(visible[0].target.id);
			}
		},
		{
			root: null,
			rootMargin: '-20% 0px -55% 0px',
			threshold: [0, 0.25, 0.5, 0.75, 1],
		},
	);

	sections.forEach((section) => observer.observe(section));
	setActive(sections[0].id);
}

export function initCaseStudyDetailToc() {
	initDetailToc('.js-cs-detail-toc', '.js-cs-detail-toc-link');
	initDetailToc('.js-article-detail-toc', '.js-article-detail-toc-link');
}
